import styled from 'styled-components/macro';
import { hideVisually } from 'polished';

import { SearchFieldContainer } from 'components/styled/SearchField/SearchField';
import { ReactComponent as ChevronSVG } from 'icons/icon-chevron.svg';

import { boxShadow, helperText, definitionLabel } from 'styles/base-classes';
import modularScale from 'styles/helpers/modular-scale';
import { ThemeProps } from 'types/styled';

export const Button = styled.button<any>`
  font-weight: 600;
  ${({ theme }): string => `
    padding: ${theme.spacing.xxsmall} ${theme.spacing.small};
    border: 1px solid ${theme.Grey};
    color: ${theme.NightBlue};
  `}
`;

export const Chevron = styled(ChevronSVG)<any>`
  ${({ theme, isOpen }): string => `
    width: ${theme.spacing.small};
    height: ${theme.spacing.small};
    margin-left: ${theme.spacing.small};
    color: ${theme.NightBlue};
    transition: transform 200ms;
    transform: ${isOpen ? 'rotate(270deg)' : 'rotate(90deg)'};
    transition-timing-function: ${theme.timingFunction};
  `}
`;

export const Absolute = styled.div`
  position: absolute;
  background: white;
  z-index: 1000;
  right: 0;
  ${boxShadow};
`;

export const Relative = styled.div`
  position: relative;
`;

export const Container = styled('div')`
  border: 1px solid ${({ theme }): string => theme.Grey};

  ${SearchFieldContainer} {
    margin-bottom: 0;
  }

  figcaption {
    ${definitionLabel};
    margin-bottom: ${({ theme }): string => theme.spacing.medium};
  }

  figure {
    margin: 0;
    margin-top: ${({ theme }): string => theme.spacing.medium};
  }
`;

export const Header = styled('div')`
  margin-bottom: 0;
  padding: ${({ theme }): string => theme.spacing.small};
  border-bottom: 1px solid ${({ theme }): string => theme.Grey};
`;

export const Content = styled('div')<ThemeProps<'div'>>`
  padding: ${({ theme }): string => theme.spacing.small};
  max-height: ${({ checkedLimitReached }): string =>
    checkedLimitReached ? '20em' : '25em'};
  overflow-y: scroll;
  overscroll-behavior-y: contain;
  -webkit-overflow-scrolling: touch;
`;

export const ListItem = styled('li')`
  margin: ${({ theme }): string => theme.spacing.small} 0;

  input {
    ${hideVisually};
  }
`;

export const HelperText = styled('p')`
  ${helperText};
`;

export const CheckboxLabel = styled.label<ThemeProps<'label'>>`
  display: flex;
  align-items: center;
  text-align: center;

  ${({ theme, styleAsInactive, withoutCheckbox, compact }): string => `
    margin-left: ${withoutCheckbox ? '1.8em' : '0'};
    justify-content: ${compact ? 'center' : 'left'};

    > span {
      transition: opacity ${theme.transitionDuration} ${theme.timingFunction};
      color: ${styleAsInactive ? theme.CasperGrey : 'initial'};
    }

    svg {
      transition: opacity ${theme.transitionDuration} ${theme.timingFunction};
    }
  `}
`;

export const MaxLimitMessage = styled.p`
  max-width: 15rem;
  padding: ${({ theme }): string => theme.spacing.medium};
  margin: 0 auto;
  font-size: ${modularScale(-1)};
`;
